/* eslint-disable no-console */
import { useEffect } from 'react'
import store from '../../redux/store'

function useReduxStateDebug<T>(
  selector: (state: any) => T,
  name = 'State Debug',
): void {
  useEffect(() => {
    const initialState = selector(store.getState())
    console.group(`[${name}] Initial State`)
    console.log('Current value:', initialState)
    console.groupEnd()

    const unsubscribe = store.subscribe(() => {
      const newState = selector(store.getState())
      console.group(`[${name}] State Updated`)
      console.log('Current value:', newState)
      console.groupEnd()
    })

    return () => unsubscribe()
  }, [selector, name])
}

export default useReduxStateDebug
